import { useEffect } from "react";
import { createPortal } from "react-dom";
import { useUIStore } from "@/store/ui";
import DealThread from "./DealThread";

/** Side panel that slides in over the current page to show one deal. */
export default function DealDrawer() {
  const dealId = useUIStore((s) => s.openDealId);
  const closeDeal = useUIStore((s) => s.closeDeal);

  useEffect(() => {
    if (!dealId) return;
    const onKey = (e: KeyboardEvent) => {
      // Let an open dialog (confirm, handoff) handle Escape first.
      if (e.key === "Escape" && !document.querySelector('[role="dialog"],[role="alertdialog"]'))
        closeDeal();
    };
    window.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [dealId, closeDeal]);

  if (!dealId) return null;
  return createPortal(
    <div className="fixed inset-0 z-50">
      <div className="overlay-backdrop" onClick={closeDeal} />
      <section
        aria-label="Deal"
        className="absolute inset-y-0 right-0 w-full md:w-[min(1100px,96vw)] bg-ink-950 border-l border-fg/[0.08] shadow-soft animate-slide-in"
      >
        <DealThread key={dealId} dealId={dealId} onClose={closeDeal} />
      </section>
    </div>,
    document.body,
  );
}
